module.exports = __webpack_public_path__ + "static/media/Panorama-Wellington-pano.24835974.jpg";